<template>
  <v-dialog
      v-model="dialog"
      scrollable
      width="400"
  >
    <v-card>
      <v-card-title>Stammauftrag auswählen</v-card-title>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suchen"
          single-line
          hide-details
      ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="dialog">
        <v-list-item-group v-model="selectedItem" color="primary" style="max-height: 450px;">
          <v-list-group
              v-for="item in filteredList"
              :key="item.id"
              :value="item.expanded"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title :ref="item.id">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
                v-for="entry in item.entries"
                :key="entry.id"
                :value="entry"
            >
              <v-list-item-content>
                <v-list-item-title>{{ entry.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list-item-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="!isSubLevelSelected"
            @click="dialog = false; $emit('select', selectedItem)"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectAufisnDialog",
  props: {
    aufisns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      selected: null,
      search: '',
      selectedItem: null,
      items: [],
    };
  },
  computed: {
    filteredList() {
      if (!this.search) {
        return this.items;
      }
      const searchLower = this.search.toLowerCase();
      return this.items.map(item => {
        if (!item.entries || item.entries.length === 0) {
          return null; // Skip items without entries
        }
        const filteredEntries = item.entries.filter(entry =>
            entry.name.toLowerCase().includes(searchLower)
        );
        if (item.name.toLowerCase().includes(searchLower) || filteredEntries.length > 0) {
          return {
            ...item,
            entries: filteredEntries.length > 0 ? filteredEntries : item.entries
          };
        }
        return null;
      }).filter(Boolean);
    },
    isSubLevelSelected() {
      if (!this.selectedItem) {
        return false;
      }
      // Check if the selected ID belongs to a sub-level entry
      return this.items.some(item => {
        if (item.entries === undefined) {
          return false;
        }
            return item.entries.some(entry => entry.id === this.selectedItem.id);
          }
      );
    },
  },
  methods: {
    open(preselect) {
      this.search = null;
      this.selectedItem = null;
      let items = JSON.parse(JSON.stringify(this.aufisns));
      let found = false;
      for (let i = 0; i < items.length; i++) {
        items[i].expanded = items[i].id === preselect;
        if (items[i].expanded) {
          found = true;
        }
      }
      this.items = items;
      this.dialog = true;
      if (found) {
        this.$nextTick(() => {
          setTimeout(() => {
            let element = this.$refs[preselect];
            if (element && element.length > 0) {
              element[0].scrollIntoView({behavior: 'smooth', block: 'center'});
            }
          }, 500);
        });
      }
    }
  },
}
</script>

<style scoped>

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

::v-deep .v-list-item__action {
  margin: 6px 0;
}

::v-deep .v-list-item__content {
  padding: 6px 0;
}

::v-deep .v-list-item {
  min-height: 38px;
  transform: translate(0, 0);
  padding: 0 10px;
}

::v-deep .v-list-group__items {
  padding-left: 18px;
}

</style>
